import { useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { Button, CircularProgress, Stack, Typography } from "@mui/material";
import { GridRowId } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { DeleteRowsDialog } from "./components/DeleteRowsDialog";

interface Props {
	selectedRowsId?: GridRowId[];
	onDeleteRows?: VoidFunction;
	deleteLoading?: boolean;
}

const TableSelectActions = ({ selectedRowsId, onDeleteRows, deleteLoading }: Props) => {
	const { t } = useTranslation("common");

	const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

	const handleOpenDeleteDialog = () => setOpenDeleteDialog(true);
	const handleCloseDeleteModal = () => setOpenDeleteDialog(false);

	const selectedRowsCount = selectedRowsId?.length ?? 0;

	const handleDelete = async () => {
		if (!onDeleteRows) return;

		try {
			await onDeleteRows(); // wait for delete
			handleCloseDeleteModal(); // close ONLY if success
		} catch (e) {
			// optional: show error toast
			console.error(e);
		}
	};

	return (
		<Stack>
			<Stack
				sx={{
					px: 2,
					py: 1,
					display: "flex",
					justifyContent: "flex-start",
					alignItems: "center",
				}}
				spacing={2}
				direction="row"
			>
				<Typography variant="body2" color="primary">
					<strong>{selectedRowsCount}</strong>{" "}
					{selectedRowsCount > 1 ? t("selected elements") : t("selected element")}
				</Typography>
				<Stack direction="row" spacing={2}>
					<Button disabled onClick={() => {}} size="medium" color="primary" endIcon={<FileDownloadIcon />}>
						<Typography variant="body2" color="primary">
							{t("export")}
						</Typography>
					</Button>
					<Button
						onClick={handleOpenDeleteDialog}
						disabled={selectedRowsCount === 0 || deleteLoading}
						size="medium"
						color="primary"
						endIcon={deleteLoading ? <CircularProgress size={18} /> : <DeleteIcon />}
					>
						<Typography variant="body2" color="primary">
							{t("delete")}
						</Typography>
					</Button>
				</Stack>
			</Stack>

			<DeleteRowsDialog
				open={openDeleteDialog}
				handleClose={handleCloseDeleteModal}
				count={selectedRowsCount}
				onDelete={handleDelete}
				isLoading={deleteLoading}
			/>
		</Stack>
	);
};

export default TableSelectActions;
